module.exports = __webpack_public_path__ + "static/media/TeamLeadImg.f872e888.png";